import {
  Box,
  CircularProgress,
  Dialog,
  IconButton,
  TableCell,
  LinearProgress,
  Pagination,
  DialogContent,
  Button,
} from '@mui/material'
import React, { useState } from 'react'
import { CancelOutlined, GetApp as GetAppIcon, Visibility } from '@mui/icons-material'
import { useAuthContext } from '../../../../hooks/useAuthContext'
import { fileServices } from '../../../../services/fileServices'
import { downloadBlob } from '../../../../utility/fileUtil'
import { getPDFPreviewData } from '../../../../utility/utilityFunctions'
import LongMenu from '../../../../pages/DataEntryPage/Fields/LongMenu'
import FilePreview from './FilePreview'
import { useResponsiveTypography } from '../../../../utility/responsiveTypography'

const TableCellFile = ({ color, isHidden, value, width }) => {
  const { user } = useAuthContext()
  const [isLoading, setIsLoading] = useState(false)
  const [images, setImages] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [previewLoading, setPreviewLoading] = useState(false)
  const [isDialogOpen, setIsDialogOpen] = useState(false)
  const { previewText } = useResponsiveTypography()

  const itemsPerPage = 1

  const totalPages = Math.ceil(images.length / itemsPerPage)

  const downloadFile = async (fileName) => {
    setIsLoading(true)
    await fileServices.downloadFile(user, fileName)
    setIsLoading(false)
  }

  const handlePageChange = (event, value) => {
    setCurrentPage(value)
  }

  const getPreviewData = async (fileKey) => {
    setPreviewLoading(true)
    let result = await getPDFPreviewData(fileKey, user)
    setImages(result)
    setPreviewLoading(false)
  }

  const handlePreviewClick = (fileKey) => {
    getPreviewData(fileKey)
    setPreviewLoading(true)
    setIsDialogOpen(true)
  }

  const handleCloseDialog = () => {
    setIsDialogOpen(false)
    setPreviewLoading(false)
  }

  const options = [
    {
      label: 'Preview',
      icon: (
        <IconButton size="small">
          {images == null ? <CircularProgress color="primary" size={'25px'} /> : <Visibility />}
        </IconButton>
      ),
      onClick: () => handlePreviewClick(value),
    },
    {
      label: 'Download',
      icon: (
        <IconButton size="small">
          {isLoading ? <CircularProgress color="info" size={'25px'} /> : <GetAppIcon />}
        </IconButton>
      ),
      onClick: () => downloadFile(value),
    },
  ]

  return (
    <TableCell
      sx={{
        width: width + 'rem',
        color: color,
        display: isHidden ? 'none' : '',
        fontSize: previewText,
      }}
    >
      {value && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          {value}

          <LongMenu options={options} />

          <FilePreview
            isLoading={isLoading}
            images={images}
            currentPage={currentPage}
            previewLoading={previewLoading}
            isDialogOpen={isDialogOpen}
            onPageChange={handlePageChange}
            onPreviewClick={handlePreviewClick}
            onCloseDialog={handleCloseDialog}
          />
        </Box>
      )}
    </TableCell>
  )
}

export default TableCellFile
